import React from "react";
import Terms from "components/Terms/Terms"
import { VertContainer, VertButton } from "@vertem-core/vertice-ds";
import { useDispatch, useSelector } from "react-redux";
import { signTerm } from "redux/Reducers/PopBallon/VertemGiftApi";
import { VertTypography } from "@vertem-core/vertice-ds";


export const TermsPage = () => {
    const dispatch = useDispatch();

    return (
        <VertContainer style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', marginTop: '2%' }}>
            <VertTypography.Title level={1} className="margin-y-none padding-bottom-small" style={{ color: '#066ddc' }}>
                Termos do Aniversário Acessa Agro
            </VertTypography.Title>
            <div style={{ width: '60%', }}>
                <Terms />
            </div>
            <div style={{ marginTop: '20px', marginBottom: '20px' }}>
                <VertButton
                    type="highlight"
                    className="btn-accept"
                    onClick={() => dispatch(signTerm())}
                >
                    Li e Aceito os Termos da Campanha
                </VertButton>
            </div>
        </VertContainer>
    );
}